import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { MACROECONOMICS_TAB } from '../constant'
import { changeActiveTab, selectActiveTab } from '../store/slice'
import classes from './index.module.scss'

export const Left = () => {
  const dispatch = useDispatch()

  const activeTab = useSelector(selectActiveTab)

  const onClickTab = (item) => () => {
    dispatch(changeActiveTab(item.key))
  }

  return (
    <div className={classes.tab}>
      {Object.values(MACROECONOMICS_TAB).map((tab) => (
        <Element
          key={tab.key}
          className={classes.tabItem}
          style={{
            color: tab.key === activeTab ? '#ffffff' : '#191D25',
            backgroundColor: tab.key === activeTab ? '#2C73E8' : '#ebebeb',
          }}
          onClick={onClickTab(tab)}
        >
          <Translate value={tab.label} />
        </Element>
      ))}
    </div>
  )
}
